import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all cities
export const fetchCities = createAsyncThunk("cities/fetchCities", async (params = {}) => {
  const { page = 1, per_page = 100 } = params;
  try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    const token = user?.token;
    const response = await axios.get(
      `${BASE_URL}/dashboard/cities`,
      {
        params: { page, per_page },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    return message;
  }
});

// add cities
export const addCities = createAsyncThunk(
  "cities/add",
  async (userData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/cities`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت إضافة المدينة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة المدينة";
      return rejectWithValue(message);
    }
  }
);
// get cities record
export const citiesRecord = createAsyncThunk(
  "cities/citiesRecord",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/cities/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات المدينة";
      return rejectWithValue(message);
    }
  }
);
// update cities
export const updateCities = createAsyncThunk(
  "cities/updateCities",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/cities/${id}/update`,
        { ...formData },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت تحديث المدينة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث المدينة";
      return rejectWithValue(message);
    }
  }
);
// delete city
export const deleteCities = createAsyncThunk(
  "cities/deleteCities",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/cities/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف المدينة";
      return rejectWithValue(message);
    }
  }
);
const CitiesSlice = createSlice({
  name: "cities",
  initialState: {
    cities: [],
    record: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta;
        state.cities = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(citiesRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(citiesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(citiesRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteCities.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCities.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside cities
        if (state.cities?.data) {
          state.cities.data = state.cities.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete cities";
      });
  },
});

export const { clearState } = CitiesSlice.actions;
export default CitiesSlice.reducer;
